module.exports = __webpack_public_path__ + "static/img/7.64574884.png";